import React from 'react'
import { Button, Popconfirm } from 'antd'
import { ImagePreview } from '../../../../../../../components'
import './OutfitCard.scss'

/**
 * Reusable outfit card component for displaying outfit in grid
 *
 * @param {Object} props
 * @param {Object} props.outfit - Outfit data (id, tag, primary_image, name)
 * @param {Function} props.onClick - Card click handler
 * @param {Boolean} props.showDelete - Show delete button
 * @param {Function} props.onDelete - Delete handler
 * @param {Boolean} props.isSelected - Whether this card is selected
 * @param {String} props.className - Additional class names
 */
const OutfitCard = ({
  outfit,
  onClick,
  showDelete = false,
  onDelete,
  isSelected = false,
  className = ''
}) => {
  if (!outfit) return null

  const handleClick = () => {
    if (onClick) onClick(outfit)
  }

  const handleDelete = e => {
    e && e.stopPropagation()
    if (onDelete) onDelete(outfit)
  }

  return (
    <div
      className={`outfit-card ${isSelected ? 'selected' : ''} ${className}`}
      onClick={handleClick}
    >
      <div className="card-image-container">
        <img
          src={outfit.primary_image}
          alt={outfit.name || outfit.tag}
          className="outfit-image"
        />
      </div>

      <div className="card-footer">
        <div className="card-info">
          <div className="outfit-name">{outfit.name || 'Untitled Outfit'}</div>
          <div className="outfit-tag">{outfit.tag || outfit.id}</div>
        </div>

        {showDelete && onDelete && (
          <div className="card-actions" onClick={e => e.stopPropagation()}>
            <Popconfirm
              title="Delete this outfit from library?"
              onConfirm={handleDelete}
              okText="Delete"
              cancelText="Cancel"
              okButtonProps={{ type: 'danger' }}
            >
              <Button type="link" icon="delete" className="delete-btn" />
            </Popconfirm>
          </div>
        )}
      </div>
    </div>
  )
}

export default OutfitCard
